(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["molli-b2b-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const forms = document.querySelectorAll('.molli-b2b__form');
    if (!forms.length) return;

    forms.forEach(function (form) {
      const noteInput = form.querySelector('[data-b2b-note]');
      if (!noteInput) return;

      form.addEventListener('submit', function () {
        const fields = form.querySelectorAll('[data-b2b-field]');
        const parts = [];
        fields.forEach(function (el) {
          const label = el.getAttribute('data-b2b-field');
          const value = (el.value || '').trim();
          if (value) parts.push(label + ': ' + value);
        });
        noteInput.value = parts.join('\n');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["molli-bento"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('.molli-bento[data-animate="true"]');
    if (!sections.length || !('IntersectionObserver' in window)) {
      sections.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    const io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.15 });
    sections.forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["molli-compare"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const allDetails = document.querySelectorAll('.molli-compare__mobile-details');
    if (!allDetails.length) return;

    const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    allDetails.forEach(function (d) {
      const wrap = d.querySelector('.molli-compare__mobile-body-wrap');
      if (!wrap) return;
      wrap.style.height = d.open ? 'auto' : '0px';
    });

    allDetails.forEach(function (d) {
      const summary = d.querySelector('summary');
      const wrap = d.querySelector('.molli-compare__mobile-body-wrap');
      if (!summary || !wrap) return;

      summary.addEventListener('click', function (e) {
        if (reduceMotion) return;
        e.preventDefault();

        if (d.open) {
          const currentHeight = wrap.scrollHeight;
          wrap.style.height = currentHeight + 'px';
          requestAnimationFrame(function () {
            requestAnimationFrame(function () { wrap.style.height = '0px'; });
          });
          const onEnd = function () {
            d.open = false;
            wrap.removeEventListener('transitionend', onEnd);
          };
          wrap.addEventListener('transitionend', onEnd);
        } else {
          d.open = true;
          const targetHeight = wrap.scrollHeight;
          wrap.style.height = '0px';
          requestAnimationFrame(function () {
            requestAnimationFrame(function () { wrap.style.height = targetHeight + 'px'; });
          });
          const onEnd = function () {
            wrap.style.height = 'auto';
            wrap.removeEventListener('transitionend', onEnd);
          };
          wrap.addEventListener('transitionend', onEnd);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["molli-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const allDetails = document.querySelectorAll('.molli-faq__details');
    if (!allDetails.length) return;

    const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Sync initial state for items that start open
    allDetails.forEach(function (d) {
      const wrap = d.querySelector('.molli-faq__answer-wrap');
      if (!wrap) return;
      if (d.open) {
        wrap.style.height = 'auto';
      } else {
        wrap.style.height = '0px';
      }
    });

    allDetails.forEach(function (d) {
      const summary = d.querySelector('summary');
      const wrap = d.querySelector('.molli-faq__answer-wrap');
      if (!summary || !wrap) return;

      summary.addEventListener('click', function (e) {
        if (reduceMotion) return;
        e.preventDefault();

        if (d.open) {
          const currentHeight = wrap.scrollHeight;
          wrap.style.height = currentHeight + 'px';
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              wrap.style.height = '0px';
            });
          });
          const onEnd = function () {
            d.open = false;
            wrap.removeEventListener('transitionend', onEnd);
          };
          wrap.addEventListener('transitionend', onEnd);
        } else {
          d.open = true;
          const targetHeight = wrap.scrollHeight;
          wrap.style.height = '0px';
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              wrap.style.height = targetHeight + 'px';
            });
          });
          const onEnd = function () {
            wrap.style.height = 'auto';
            wrap.removeEventListener('transitionend', onEnd);
          };
          wrap.addEventListener('transitionend', onEnd);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["molli-finishes"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('.molli-finishes[data-animate="true"]');
    if (!sections.length || !('IntersectionObserver' in window)) {
      sections.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    const io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.15 });
    sections.forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["molli-layers"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('.molli-layers[data-animate="true"]');
    if (!sections.length || !('IntersectionObserver' in window)) {
      sections.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    const io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.15 });
    sections.forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["molli-moments"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('.molli-moments[data-animate="true"]');
    if (!sections.length || !('IntersectionObserver' in window)) {
      sections.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    const io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.15 });
    sections.forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["molli-problem"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('.molli-problem[data-animate="true"]');
    if (!sections.length || !('IntersectionObserver' in window)) {
      sections.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    const io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.15 });
    sections.forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["molli-science"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('.molli-science[data-animate="true"]');
    if (!sections.length || !('IntersectionObserver' in window)) {
      sections.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    const io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.15 });
    sections.forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["molli-sticky-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const bars = document.querySelectorAll('.molli-sticky-bar');
    if (!bars.length) return;

    const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function getHeaderHeight() {
      // Horizon and many themes
      const candidates = [
        '#header-group',
        '.shopify-section-group-header-group',
        'header[role="banner"]',
        '#shopify-section-header',
        '.section-header',
        'header.header'
      ];
      for (const sel of candidates) {
        const el = document.querySelector(sel);
        if (el) {
          const rect = el.getBoundingClientRect();
          if (rect.height > 0) return Math.round(rect.height);
        }
      }
      return 0;
    }

    function applyHeaderOffset(bar) {
      const h = getHeaderHeight();
      bar.style.setProperty('--msb-top-offset', h + 'px');
    }

    function findMainProductForm() {
      const forms = document.querySelectorAll('form[action*="/cart/add"]');
      for (const f of forms) {
        if (!f.closest('.molli-sticky-bar')) return f;
      }
      return null;
    }

    bars.forEach(function (bar) {
      let variants;
      try { variants = JSON.parse(bar.dataset.variants || '[]'); } catch (e) { variants = []; }

      const initialId = parseInt(bar.dataset.initialVariant, 10);
      const triggerScroll = parseInt(bar.dataset.triggerScroll, 10) || 0;
      const showCart = bar.dataset.showCart === 'true';
      const showWl = bar.dataset.showWaitlist === 'true';
      const waitlistBehavior = bar.dataset.waitlistBehavior;
      const waitlistTarget = bar.dataset.waitlistTarget;

      const swatch = bar.querySelector('[data-swatch]');
      const priceEl = bar.querySelector('[data-price]');
      const variantInput = bar.querySelector('[data-variant-input]');
      const atcButton = bar.querySelector('[data-atc-button]');
      const atcLabel = bar.querySelector('[data-atc-label]');
      const cartForm = bar.querySelector('[data-cart-form]');
      const wlButton = bar.querySelector('[data-wl-button]');
      const wlModal = bar.querySelector('[data-wl-modal]');
      const wlClose = bar.querySelector('[data-wl-close]');
      const toast = bar.querySelector('[data-toast]');

      // Header offset detection.
      // The header element may not be in the DOM when section JS first runs,
      // and its height can change (transparent header collapse, sticky shrink, etc).
      // Re-apply: now, on DOM ready, on full load, on every scroll/resize, plus a
      // short poll for the first few seconds.
      applyHeaderOffset(bar);
      let headerAttempts = 0;
      const headerPoll = setInterval(function () {
        applyHeaderOffset(bar);
        headerAttempts++;
        if (getHeaderHeight() > 0 || headerAttempts > 30) clearInterval(headerPoll);
      }, 200);
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { applyHeaderOffset(bar); }, { once: true });
      }
      window.addEventListener('load', function () { applyHeaderOffset(bar); }, { once: true });
      window.addEventListener('resize', function () { applyHeaderOffset(bar); }, { passive: true });
      window.addEventListener('scroll', function () { applyHeaderOffset(bar); }, { passive: true });

      function findVariant(id) {
        const target = parseInt(id, 10);
        return variants.find(function (v) { return v.id === target; });
      }

      function updateVariant(id) {
        const v = findVariant(id);
        if (!v) return;
        if (swatch) {
          if (v.color) {
            swatch.style.backgroundColor = v.color;
            swatch.style.backgroundImage = '';
          } else if (v.image) {
            swatch.style.backgroundImage = 'url(' + v.image + ')';
            swatch.style.backgroundColor = '';
          }
        }
        if (priceEl) priceEl.textContent = v.price;
        if (variantInput) variantInput.value = v.id;
        if (atcButton && atcLabel) {
          if (v.available) {
            atcButton.disabled = false;
            atcLabel.textContent = atcLabel.getAttribute('data-default') || atcLabel.textContent;
          } else {
            atcButton.disabled = true;
            const soldLabel = bar.getAttribute('data-sold-label') || 'Sold out';
            atcLabel.textContent = soldLabel;
          }
        }
      }

      if (atcLabel) atcLabel.setAttribute('data-default', atcLabel.textContent);

      // Init
      updateVariant(initialId);

      // ---- Variant change detection ----
      // 1) Horizon native event (variant:update bubbles up the DOM)
      document.addEventListener('variant:update', function (e) {
        try {
          const v = e && e.detail && (e.detail.variant || e.detail.resource);
          if (v && v.id) updateVariant(v.id);
        } catch (err) {}
      });
      document.addEventListener('variant:selected', function (e) {
        try {
          const v = e && e.detail && (e.detail.variant || e.detail.resource);
          if (v && v.id) updateVariant(v.id);
        } catch (err) {}
      });

      // 2) URL change (?variant=ID)
      function getVariantIdFromUrl() {
        try { return new URL(window.location.href).searchParams.get('variant'); }
        catch (e) { return null; }
      }
      function onUrlChange() {
        const id = getVariantIdFromUrl();
        if (id) updateVariant(id);
      }
      ['pushState', 'replaceState'].forEach(function (method) {
        const orig = history[method];
        history[method] = function () {
          const ret = orig.apply(this, arguments);
          window.dispatchEvent(new Event('molli:urlchange'));
          return ret;
        };
      });
      window.addEventListener('molli:urlchange', onUrlChange);
      window.addEventListener('popstate', onUrlChange);

      // 3) Form input change (theme-agnostic fallback)
      document.addEventListener('change', function (e) {
        const target = e.target;
        if (!target || !target.name) return;
        if (target.closest('.molli-sticky-bar')) return;
        if (target.name === 'id') {
          updateVariant(target.value);
          return;
        }
        // Option pickers may not directly update id input synchronously
        setTimeout(function () {
          const mainForm = findMainProductForm();
          const mainIdInput = mainForm && mainForm.querySelector('input[name="id"]');
          if (mainIdInput && mainIdInput.value) {
            updateVariant(mainIdInput.value);
          } else {
            const urlId = getVariantIdFromUrl();
            if (urlId) updateVariant(urlId);
          }
        }, 80);
      });

      // 4) Periodic poll as a safety net
      let lastKnownId = initialId;
      setInterval(function () {
        const mainForm = findMainProductForm();
        const mainIdInput = mainForm && mainForm.querySelector('input[name="id"]');
        if (mainIdInput && mainIdInput.value) {
          const id = parseInt(mainIdInput.value, 10);
          if (id && id !== lastKnownId) {
            lastKnownId = id;
            updateVariant(id);
          }
        }
      }, 600);

      // ---- Show/hide ----
      function setVisible(visible) { bar.classList.toggle('is-visible', visible); }

      if (triggerScroll > 0) {
        const onScroll = function () { setVisible(window.scrollY >= triggerScroll); };
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      } else if ('IntersectionObserver' in window) {
        // Wait for the main product form to exist in the DOM, then observe it.
        // Only show the bar AFTER the form has been visible at least once
        // and then leaves the viewport. Prevents false-positive on page-load
        // scroll restoration or when form starts below the fold.
        let attempts = 0;
        let hasBeenVisible = false;
        let observerAttached = false;

        const tryAttach = function () {
          if (observerAttached) return true;
          const mainForm = findMainProductForm();
          if (!mainForm) return false;
          observerAttached = true;

          // If the form is already visible right now (most common case at page load
          // where the user is at the top), mark it as having been visible so the
          // first scroll-past triggers the bar.
          const rect = mainForm.getBoundingClientRect();
          const vh = window.innerHeight || document.documentElement.clientHeight;
          if (rect.top < vh && rect.bottom > 0) {
            hasBeenVisible = true;
          }

          const io = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                hasBeenVisible = true;
                setVisible(false);
              } else if (hasBeenVisible) {
                setVisible(true);
              }
            });
          }, { rootMargin: '0px 0px 0px 0px', threshold: 0 });
          io.observe(mainForm);
          return true;
        };

        if (!tryAttach()) {
          const onReady = function () { tryAttach(); };
          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', onReady, { once: true });
          }
          window.addEventListener('load', onReady, { once: true });

          const poll = setInterval(function () {
            attempts++;
            if (tryAttach() || attempts > 30) clearInterval(poll);
          }, 200);
        }
      } else {
        setVisible(true);
      }

      // ---- Add to cart (AJAX) ----
      if (cartForm) {
        cartForm.addEventListener('submit', function (e) {
          if (!atcButton || atcButton.disabled) return;
          e.preventDefault();
          atcButton.disabled = true;
          const originalLabel = atcLabel ? atcLabel.textContent : '';
          if (atcLabel) atcLabel.textContent = 'Adding…';

          const formData = new FormData(cartForm);
          const cartUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
            ? window.Shopify.routes.root + 'cart/add.js'
            : '/cart/add.js';

          fetch(cartUrl, {
            method: 'POST',
            headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: formData
          })
            .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
            .then(function (res) {
              if (!res.ok) throw new Error(res.data.description || 'Could not add to cart');
              showToast('Added to cart', 'success');
              if (atcLabel) atcLabel.textContent = 'Added';
              setTimeout(function () {
                if (atcLabel) atcLabel.textContent = originalLabel;
                atcButton.disabled = false;
              }, 1500);
              document.dispatchEvent(new CustomEvent('cart:update'));
              window.dispatchEvent(new CustomEvent('cart:added', { detail: res.data }));
            })
            .catch(function (err) {
              showToast(err.message || 'Could not add to cart', 'error');
              if (atcLabel) atcLabel.textContent = originalLabel;
              atcButton.disabled = false;
            });
        });
      }

      function showToast(msg, type) {
        if (!toast) return;
        toast.textContent = msg;
        toast.setAttribute('data-type', type || 'success');
        toast.classList.add('is-visible');
        clearTimeout(toast._t);
        toast._t = setTimeout(function () { toast.classList.remove('is-visible'); }, 2200);
      }

      // ---- Waitlist ----
      if (wlButton) {
        wlButton.addEventListener('click', function () {
          if (waitlistBehavior === 'scroll' && waitlistTarget) {
            const el = document.querySelector(waitlistTarget);
            if (el) {
              el.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
              return;
            }
          }
          if (waitlistBehavior === 'link' && waitlistTarget) {
            window.location.href = waitlistTarget;
            return;
          }
          if (wlModal && typeof wlModal.showModal === 'function') {
            wlModal.showModal();
            document.body.style.overflow = 'hidden';
          }
        });
      }
      if (wlClose && wlModal) {
        wlClose.addEventListener('click', function () {
          if (typeof wlModal.close === 'function') wlModal.close();
        });
      }
      if (wlModal) {
        wlModal.addEventListener('click', function (e) { if (e.target === wlModal) wlModal.close(); });
        wlModal.addEventListener('close', function () { document.body.style.overflow = ''; });
        wlModal.addEventListener('cancel', function () { document.body.style.overflow = ''; });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["molli-strike"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('.molli-strike[data-animate="true"]');
    if (!sections.length) return;

    const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return;

    let ticking = false;

    function update() {
      const vh = window.innerHeight || document.documentElement.clientHeight;

      sections.forEach(function (el) {
        const rect = el.getBoundingClientRect();
        const totalRange = rect.height - vh;
        if (totalRange <= 0) {
          el.style.setProperty('--scroll-progress', '1');
          return;
        }
        const scrolledIntoSection = -rect.top;
        const progress = Math.max(0, Math.min(1, scrolledIntoSection / totalRange));
        el.style.setProperty('--scroll-progress', progress.toFixed(4));
      });

      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["molli-video-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('.molli-vg');
    if (!sections.length) return;

    sections.forEach(function (section) {
      const modal = section.querySelector('.molli-vg__modal');
      const playerHost = section.querySelector('[data-vg-player]');
      const closeBtn = section.querySelector('[data-vg-close]');
      const triggers = section.querySelectorAll('[data-vg-trigger]');

      function escapeHtml(str) {
        return String(str || '').replace(/[&<>"']/g, function (c) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
      }

      function buildPlayer(trigger) {
        const sourceType = trigger.getAttribute('data-vg-source-type');
        const videoSrc = trigger.getAttribute('data-vg-video-src');
        const videoUrl = trigger.getAttribute('data-vg-video-url');

        if (sourceType === 'shopify' && videoSrc) {
          return '<video class="molli-vg__modal-video" controls autoplay playsinline src="' + escapeHtml(videoSrc) + '"></video>';
        }

        if (sourceType === 'url' && videoUrl) {
          const u = videoUrl.toLowerCase();
          if (u.indexOf('youtube.com') > -1 || u.indexOf('youtu.be') > -1) {
            let id = '';
            if (u.indexOf('youtu.be/') > -1) id = videoUrl.split('youtu.be/')[1].split(/[?&]/)[0];
            else if (u.indexOf('v=') > -1) id = videoUrl.split('v=')[1].split('&')[0];
            else if (u.indexOf('/embed/') > -1) id = videoUrl.split('/embed/')[1].split(/[?&]/)[0];
            if (id) {
              const src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
              return '<iframe class="molli-vg__modal-iframe" src="' + escapeHtml(src) + '" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
            }
          }
          if (u.indexOf('vimeo.com') > -1) {
            const id = videoUrl.split('vimeo.com/')[1].split(/[?\/]/)[0];
            if (id) {
              const src = 'https://player.vimeo.com/video/' + id + '?autoplay=1&dnt=1';
              return '<iframe class="molli-vg__modal-iframe" src="' + escapeHtml(src) + '" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" allowfullscreen></iframe>';
            }
          }
          return '<video class="molli-vg__modal-video" controls autoplay playsinline src="' + escapeHtml(videoUrl) + '"></video>';
        }

        return '<p class="molli-vg__modal-error">No video source set.</p>';
      }

      function openModal(trigger) {
        if (!modal || !playerHost) return;
        playerHost.innerHTML = buildPlayer(trigger);
        if (typeof modal.showModal === 'function') {
          modal.showModal();
        } else {
          modal.setAttribute('open', '');
        }
        document.body.style.overflow = 'hidden';
      }

      function closeModal() {
        if (!modal || !playerHost) return;
        playerHost.innerHTML = '';
        if (typeof modal.close === 'function' && modal.hasAttribute('open')) {
          modal.close();
        } else {
          modal.removeAttribute('open');
        }
        document.body.style.overflow = '';
      }

      triggers.forEach(function (t) {
        t.addEventListener('click', function (e) {
          if (t.tagName !== 'BUTTON') e.preventDefault();
          openModal(t);
        });
        if (t.tagName !== 'BUTTON') {
          t.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              openModal(t);
            }
          });
        }
      });

      if (closeBtn) closeBtn.addEventListener('click', closeModal);
      if (modal) {
        modal.addEventListener('click', function (e) {
          if (e.target === modal) closeModal();
        });
        modal.addEventListener('close', function () {
          if (playerHost) playerHost.innerHTML = '';
          document.body.style.overflow = '';
        });
        modal.addEventListener('cancel', function () {
          if (playerHost) playerHost.innerHTML = '';
          document.body.style.overflow = '';
        });
      }

      // Mobile unified-carousel dot indicators.
      const trackEl = section.querySelector('.molli-vg__mtrack');
      const dots = section.querySelectorAll('[data-vg-dot]');
      if (trackEl && dots.length) {
        const items = trackEl.querySelectorAll('.molli-vg__mslide');

        function setActiveDot(index) {
          dots.forEach(function (d, i) {
            const active = i === index;
            d.classList.toggle('is-active', active);
            if (active) d.setAttribute('aria-current', 'true');
            else d.removeAttribute('aria-current');
          });
        }

        let rafId = null;
        function onScroll() {
          if (rafId) return;
          rafId = requestAnimationFrame(function () {
            rafId = null;
            const containerRect = trackEl.getBoundingClientRect();
            const containerCenter = containerRect.left + containerRect.width / 2;
            let closest = 0;
            let closestDist = Infinity;
            items.forEach(function (item, i) {
              const r = item.getBoundingClientRect();
              const itemCenter = r.left + r.width / 2;
              const dist = Math.abs(itemCenter - containerCenter);
              if (dist < closestDist) {
                closestDist = dist;
                closest = i;
              }
            });
            setActiveDot(closest);
          });
        }

        trackEl.addEventListener('scroll', onScroll, { passive: true });

        dots.forEach(function (dot, i) {
          dot.addEventListener('click', function () {
            const item = items[i];
            if (!item) return;
            const padLeft = parseFloat(getComputedStyle(trackEl).scrollPaddingLeft) || 0;
            const delta = item.getBoundingClientRect().left - trackEl.getBoundingClientRect().left - padLeft;
            trackEl.scrollBy({ left: delta, behavior: 'smooth' });
          });
        });

        onScroll();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-gallery"] && !Shopify.designMode) return;
  try {
    
  class VideoGallery extends HTMLElement {
    #controller = new AbortController();

    connectedCallback() {
      const { signal } = this.#controller;
      const dialog = this.querySelector('.vg-dialog');
      const video = dialog?.querySelector('.vg-dialog__video');
      const grid = this.querySelector('[data-vg-grid]');
      const tiles = Array.from(this.querySelectorAll('.vg-tile'));
      const dots = Array.from(this.querySelectorAll('[data-vg-dot]'));

      dots.forEach((dot, idx) => {
        dot.addEventListener(
          'click',
          () => {
            const tile = tiles[idx];
            if (!tile) return;
            tile.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
          },
          { signal }
        );
      });

      if (grid && tiles.length > 0 && dots.length > 0 && 'IntersectionObserver' in window) {
        const setActiveDot = (idx) => {
          dots.forEach((d, i) => {
            if (i === idx) d.setAttribute('aria-current', 'true');
            else d.removeAttribute('aria-current');
          });
        };
        const observer = new IntersectionObserver(
          (entries) => {
            entries
              .filter((e) => e.isIntersecting)
              .forEach((entry) => {
                const idx = tiles.indexOf(entry.target);
                if (idx !== -1) setActiveDot(idx);
              });
          },
          { root: grid, threshold: 0.55 }
        );
        tiles.forEach((tile) => observer.observe(tile));
      }

      if (!dialog || !video) return;

      this.querySelectorAll('[data-video-trigger]').forEach((trigger) => {
        trigger.addEventListener(
          'click',
          (e) => {
            e.preventDefault();
            const src = trigger.dataset.videoSrc;
            const poster = trigger.dataset.videoPoster;
            if (!src) return;
            video.src = src;
            if (poster) video.poster = poster;
            else video.removeAttribute('poster');
            if (typeof dialog.showModal === 'function') {
              dialog.showModal();
            } else {
              dialog.setAttribute('open', '');
            }
            video.play().catch(() => {});
          },
          { signal }
        );
      });

      const close = () => {
        try {
          video.pause();
        } catch (e) {}
        video.removeAttribute('src');
        video.load();
        if (dialog.open) dialog.close();
      };

      this.querySelectorAll('[data-vg-close]').forEach((el) => {
        el.addEventListener('click', close, { signal });
      });

      dialog.addEventListener(
        'close',
        () => {
          try {
            video.pause();
          } catch (e) {}
          video.removeAttribute('src');
          video.load();
        },
        { signal }
      );

      dialog.addEventListener(
        'cancel',
        (e) => {
          e.preventDefault();
          close();
        },
        { signal }
      );
    }

    disconnectedCallback() {
      this.#controller.abort();
    }
  }

  if (!customElements.get('video-gallery')) {
    customElements.define('video-gallery', VideoGallery);
  }

  } catch(e) { console.error(e); }
})();
})();
